import { createSlice } from '@reduxjs/toolkit';
import { getScheduledBatchHistory } from 'ducks/scheduled-batch-history/operators';
import { Slices } from 'ducks/slices';
import { normalizeBatches } from 'ducks/utils';

export type ScheduledBatchHistoryState = ReturnType<typeof normalizeBatches>;

const initialState: ScheduledBatchHistoryState = [];

const scheduledBatchHistorySlice = createSlice({
  name: Slices.SCHEDULED_BATCH_HISTORY,
  initialState,
  reducers: {
    clearBatches: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledBatchHistory.pending, () => {
        return initialState;
      })
      .addCase(getScheduledBatchHistory.fulfilled, (_, { payload }) => {
        return normalizeBatches(payload);
      })
      .addCase(getScheduledBatchHistory.rejected, () => {
        return initialState;
      });
  },
});

export const { clearBatches } = scheduledBatchHistorySlice.actions;

export default scheduledBatchHistorySlice.reducer;
